// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"df22f5d5","645":"df22f5d5","868":"186dfd20"}[chunkId] + ".chunk.css";
};